import React, { Component, PropTypes } from 'react'
import classnames from 'classnames'

export default class Dialog extends Component {
    static propTypes = {
        allowClose: PropTypes.bool,
        children: PropTypes.node,
        footer: PropTypes.node,
        header: PropTypes.node,
        onClose: PropTypes.func,
        size: PropTypes.string,
        subFooter: PropTypes.node,
        title: PropTypes.string,
    }

    static defaultProps = {
        allowClose: true,
    }

    onClose = (e) => {
        if (e.target.classList.contains('dialog--modal')) {
            this.props.onClose()
        }
    }

    render() {
        let closeButton = null

        if (this.props.allowClose) {
            closeButton = (
                <a
                    className="dialog__close"
                    href="#close"
                    onClick={ (e) => {
                        e.preventDefault()
                        this.props.onClose()
                    } }
                />
            )
        }

        let header = null

        if (this.props.header) {
            header = (
                <div className="dialog__header align-center">
                    <div className="dialog-header__title">
                        { this.props.header }
                    </div>
                </div>
            )
        } else {
            header = (
                <div className="dialog__header align-center">
                    { closeButton }
                    <h3>{ this.props.title }</h3>
                </div>
            )
        }

        let footer = null

        if (this.props.footer) {
            footer = (
                <div className="dialog__footer">
                    { this.props.footer }
                </div>
            )
        }

        let subFooter = null

        if (this.props.subFooter) {
            const subFooterClasses = classnames({
                'dialog__content': true,
                'dialog__content--post': true,
                'dialog__content--center': true,
            })

            subFooter = (
                <div className={ subFooterClasses }>
                    { this.props.subFooter }
                </div>
            )
        }

        const modalClasses = classnames({
            'dialog': true,
            'dialog--small': this.props.size === 'small',
            'dialog--large': this.props.size === 'large',
        })

        const modalContentClasses = classnames({
            'dialog__content': true,
        })

        return (
            <div className={ modalClasses } onClick={ this.onClose }>
                <div className={ modalContentClasses }>
                    { header }
                    <div className="dialog__body dialog__body--padded">
                        { this.props.children }
                    </div>
                    { footer }
                </div>

                { subFooter }
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./app/components/dialog.js